export function formatNumber(number) {
   var num = Math.round(number * 100) / 100;
   return num.toFixed(2);
}
